import { defineComponent as _defineComponent } from 'vue'
import AdUnit from '@/components/AdUnit.vue';
import GuideFeatured from '@/features/editorial/components/GuideFeatured.vue';
import GuideItem from '@/features/editorial/components/GuideItem.vue';
import PaginationNav from '@/components/nav/PaginationNav.vue';

import { usePagination } from '@/helpers/composables/usePagination';
import { useArticleList } from '@/features/editorial/composables/useArticleList';
import { useRoutingStore } from '@/helpers/composables/useStores';
import { useRoute } from 'vue-router/composables';
import { useI18n } from '@/helpers/composables/useI18n';

import { computed } from 'vue';


import { MetaInfo } from 'vue-meta/types/vue-meta';

const __default__ = {
	name: 'GuidePage',
	metaInfo() {
		return (this as unknown as { head: MetaInfo }).head;
	},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const pageSize = 50;
const FEATURED_AMOUNT = 4 as const;

// how many ad breaks to include in the article list for pages > 1
const adFrequency = 1;

const { currentPage, isFirstPage } = usePagination();
const { articles, lastPage, totalCount } = useArticleList({ pageSize, page: currentPage });

const { activeDomain } = useRoutingStore();
const route = useRoute();
const { t, tc } = useI18n();

const head = computed<MetaInfo>(() => {
	const page = +route.query?.page;
	const isOnPage = !Number.isNaN(page) && page > 1;

	const title = isOnPage ? t('WEBAPP_GUIDE_META_TITLE_PAGED', { page }).toString() : tc('WEBAPP_GUIDE_META_TITLE');

	const description = isOnPage
		? t('WEBAPP_GUIDE_META_DESCRIPTION_PAGED', { page }).toString()
		: tc('WEBAPP_GUIDE_META_DESCRIPTION');

	const canonicalPath = `https://${activeDomain.value}.${JW_CONFIG.DOMAIN}${route.fullPath}`;

	return {
		title,
		link: [{ vmid: 'canonical', rel: 'canonical', href: canonicalPath }],
		meta: [
			{ vmid: 'description', name: 'description', content: description },
			{ vmid: 'og:title', property: 'og:title', content: title },
			{ vmid: 'og:description', property: 'og:description', content: description },
		],
	};
});

expose({ head });

return { __sfc: true,pageSize, FEATURED_AMOUNT, adFrequency, currentPage, isFirstPage, articles, lastPage, totalCount, activeDomain, route, t, tc, head, AdUnit, GuideFeatured, GuideItem, PaginationNav }
}

})